const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  infonum: state => state.user.infonum,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  ssourl:state => state.user.ssourl,
  loginPhone: state => state.user.loginPhone,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  channel_info: state => state.user.channel_info,
}
export default getters
